<template>
    <rkm-navbar
        :open="true"
        class="rkm-navbar"
    >
        <rkm-navbar-nav-icon @click="$emit('toggle')" />

        <rkm-navbar-brand class="ml-3">
            <span>ConectaSUS</span> <span>v{{ packageJSON.version }}</span>
        </rkm-navbar-brand>

        <rkm-navbar-nav class="ml-auto rkm-navbar-nav">
            <rkm-nav-item-dropdown right>
                <template slot="button-content">
                    <rkm-icon :icon="['far', 'user-circle']" /> {{ autenticacao.usuario.cidadao.nome }}
                </template>

                <rkm-dropdown-group>
                    <rkm-dropdown-header>Você está logado como:</rkm-dropdown-header>

                    <rkm-dropdown-text>
                        <strong>Unidade: </strong> <span>{{ autenticacao.lotacao && autenticacao.lotacao.infraestrutura.unidade.nomeFantasia }}</span>
                    </rkm-dropdown-text>
                    <rkm-dropdown-text>
                        <strong>Local de atendimento: </strong> <span>{{ autenticacao.lotacao && autenticacao.lotacao.infraestrutura.nome }}</span>
                    </rkm-dropdown-text>
                    <rkm-dropdown-text>
                        <strong>CBO: </strong> <span>{{ autenticacao.lotacao && autenticacao.lotacao.ocupacao.nome }}</span>
                    </rkm-dropdown-text>
                    <rkm-dropdown-text v-if="autenticacao.usuario.registroTipo && autenticacao.usuario.registroNumero">
                        <strong>{{ autenticacao.usuario.registroTipoId == enums.tipoRegistro.OUTRO
                            ? autenticacao.usuario.registroTipoOutro
                            : autenticacao.usuario.registroTipo.sigla }}: </strong> <span>{{ autenticacao.usuario.registroNumero }}</span>
                    </rkm-dropdown-text>
                    <rkm-dropdown-text>
                        <strong>Setor: </strong> <span>{{ autenticacao.centroCusto && autenticacao.centroCusto.setor.nome }}</span>
                    </rkm-dropdown-text>
                </rkm-dropdown-group>

                <rkm-dropdown-divider />

                <rkm-dropdown-item to="/lotacao">
                    <rkm-icon icon="sync-alt" /> Trocar lotação
                </rkm-dropdown-item>

                <rkm-dropdown-item to="/cadastro/usuario-perfil">
                    <rkm-icon :icon="['far', 'user-circle']" /> Meu perfil
                </rkm-dropdown-item>

                <rkm-dropdown-divider />

                <rkm-dropdown-item
                    @click="handleLogout"
                    color="danger"
                >
                    <rkm-icon icon="door-open" /> Sair do sistema
                </rkm-dropdown-item>
            </rkm-nav-item-dropdown>
        </rkm-navbar-nav>
    </rkm-navbar>
</template>

<script>
// Mixins.
import { repository } from '@/mixins'

// Others.
import packageJSON from '/package.json'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

import tipoRegistro from '@/enums/cadastro/usuario/tipoRegistro'

export default {
    computed: {
        ...mapGetters({
            autenticacao: 'getAutenticacao',
            centroCusto: 'getCentroCusto',
            lotacao: 'getLotacao',
        }),
    },
    created() {
        this.packageJSON = packageJSON
        this.repositories = {
            autenticacao: this.getConectaSusRepository('administracao.autenticacao')
        }
    },
    data: () => ({
        logout: null,
        notification: null,
        packageJSON: null,
        enums: { tipoRegistro }
    }),
    methods: {
        ...mapActions([
            'clear',
            'setAutenticacao',
            'unsetShowExitFormConfirmation',
        ]),
        ...mapActions('notification', ['setNotification']),
        handleExpirationToken() {
            if (this.autenticacao.expiration > 0) {
                const date = new Date()
                const expiration = new Date(this.autenticacao.expiration * 1000)
                const diff = ((expiration.getTime() - date.getTime()))

                if ((diff - (300 * 1000)) > 0) {
                    this.notification = setTimeout(() => {
                        this.showWarningConfirmation(
                            'Expiração da sessão',
                            `A sessão vai expirar em 5 minutos, deseja atualizar a sessão?`,
                            async () => this.handleRefreshToken(),
                        )
                    }, diff - (300 * 1000))
                }

                this.logout = setTimeout(() => {
                    this.clear()
                        .then(customer => {
                            this.unsetShowExitFormConfirmation()
                            this.$router.push({ name: 'login', params: { customer: customer.link }})
                            this.setNotification({ visible: false })
                        })
                }, diff)
            }
        },
        handleLogout() {
            this.clearTimeouts()
            this.repositories.autenticacao.logout()
                .catch(this.handleError)
                .finally(() => {
                    this.clear()
                        .then(customer => {
                            this.unsetShowExitFormConfirmation()
                            this.$router.push({ name: 'login', params: { customer: customer.link }})
                        })
                })
        },
        handleRefreshToken() {
            this.clearTimeouts()
            this.repositories.autenticacao.refresh({
                centro_custo_id: this.centroCusto.id,
                lotacao_id: this.lotacao.id,
            })
                .then(({data}) => {
                    this.setAutenticacao(data)
                    this.handleExpirationToken()
                })
                .catch(this.handleError)
        },
        clearTimeouts() {
            clearTimeout(this.notification)
            clearTimeout(this.logout)
        }
    },
    mixins: [ repository ],
    mounted() {
        this.handleExpirationToken()
    },
}
</script>

<style scoped>
.rkm-navbar {
    color: #ffffff !important;
}
.rkm-navbar-nav >>> .nav-link {
    color: #ffffff;
}
</style>
